import { render, staticRenderFns } from "./phoneForm.vue?vue&type=template&id=82b08db4&scoped=true&"
import script from "./phoneForm.vue?vue&type=script&lang=js&"
export * from "./phoneForm.vue?vue&type=script&lang=js&"
import style0 from "./phoneForm.vue?vue&type=style&index=0&id=82b08db4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b08db4",
  null
  
)

export default component.exports